// extracted by mini-css-extract-plugin
export var smallSpinner = "_qb-0";